// extracted by mini-css-extract-plugin
export default {"container":"reject-modal_container__QC4yQ","actions":"reject-modal_actions__grD-8","observation":"reject-modal_observation__wMR5P","warning":"reject-modal_warning__bjyKE"};